module.exports = __webpack_public_path__ + "img/reference-unikat-metzler.86485d67.webp";